import { Map } from 'immutable'
import * as actionTypes from './actionTypes'

const initialState = Map({
    list: Map({
        year: null,
        data: null,
        fetching: false,
        error: null,
    }),
    details: Map({
        data: null,
        fetching: false,
        saving: false,
        deleting: false,
        error: null,
    }),
})

function reportDriverAllowances(state = initialState, action) {
    switch (action.type) {
        // Fetch
        case actionTypes.FETCH:
            return state.setIn(['list', 'year'], action.payload).setIn(['list', 'fetching'], true)
        case actionTypes.FETCH_FULFILLED:
            return state.withMutations(map => {
                map.setIn(['list', 'fetching'], false).setIn(['list', 'data'], action.payload)
            })
        case actionTypes.FETCH_REJECTED:
            return state.withMutations(map => {
                map.setIn(['list', 'fetching'], false).setIn(['list', 'error'], action.payload)
            })
        case actionTypes.FETCH_CANCELLED:
            return state.setIn(['list', 'fetching'], false)

        // Clear
        case actionTypes.CLEAR:
            return state.setIn(['list', 'data'], null)

        // Fetch details
        case actionTypes.FETCH_DETAILS:
            return state.setIn(['details', 'fetching'], true)
        case actionTypes.FETCH_DETAILS_FULFILLED:
            return state.withMutations(map => {
                map.setIn(['details', 'fetching'], false).setIn(['details', 'data'], action.payload)
            })
        case actionTypes.FETCH_DETAILS_REJECTED:
            return state.withMutations(map => {
                map.setIn(['details', 'fetching'], false).setIn(['details', 'error'], action.payload)
            })
        case actionTypes.FETCH_DETAILS_CANCELLED:
            return state.setIn(['details', 'fetching'], false)

        // Clear details
        case actionTypes.CLEAR_DETAILS:
            return state.setIn(['details', 'data'], null)

        // Save
        case actionTypes.SAVE:
            return state.withMutations(map => {
                map.setIn(['details', 'saving'], true)
            })
        case actionTypes.SAVE_FULFILLED:
            return state.withMutations(map => {
                map.setIn(['details', 'saving'], false).setIn(['details', 'data'], action.payload)
            })
        case actionTypes.SAVE_REJECTED:
            return state.withMutations(map => {
                map.setIn(['details', 'saving'], false)
            })
        case actionTypes.SAVE_CANCELLED:
            return state.withMutations(map => {
                map.setIn(['details', 'saving'], false).setIn(['details', 'error'], action.payload)
            })

        // Delete
        case actionTypes.DELETE_ALLOWANCE:
            return state.withMutations(map => {
                map.setIn(['details', 'deleting'], true)
            })
        case actionTypes.DELETE_ALLOWANCE_FULFILLED:
            return state.withMutations(map => {
                map.setIn(['details', 'deleting'], false).setIn(['details', 'data'], action.payload)
            })
        case actionTypes.DELETE_ALLOWANCE_REJECTED:
            return state.withMutations(map => {
                map.setIn(['details', 'deleting'], false)
            })
        case actionTypes.DELETE_ALLOWANCE_CANCELLED:
            return state.withMutations(map => {
                map.setIn(['details', 'deleting'], false).setIn(['details', 'error'], action.payload)
            })

        // Reassign
        case actionTypes.REASSIGN_ALLOWANCE:
            return state.withMutations(map => {
                map.setIn(['details', 'saving'], true)
            })
        case actionTypes.REASSIGN_ALLOWANCE_FULFILLED:
            return state.withMutations(map => {
                map.setIn(['details', 'saving'], false).setIn(['details', 'data'], action.payload)
            })
        case actionTypes.REASSIGN_ALLOWANCE_REJECTED:
            return state.withMutations(map => {
                map.setIn(['details', 'saving'], false)
            })
        case actionTypes.REASSIGN_ALLOWANCE_CANCELLED:
            return state.withMutations(map => {
                map.setIn(['details', 'saving'], false).setIn(['details', 'error'], action.payload)
            })

        default:
            return state
    }
}

export default reportDriverAllowances
